import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6900585a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account" }
const _hoisted_2 = { class: "main-infos" }
const _hoisted_3 = { class: "titles" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle" }

import { useAuthStore } from '@/stores';
import { computed, ComputedRef } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const user: ComputedRef<any> = computed(() => useAuthStore().user);


return (_ctx: any,_cache: any) => {
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (user.value.agency?.company.details)
        ? (_openBlock(), _createBlock(_component_avatar, {
            key: 0,
            src: user.value.agency?.company.details.logo
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(user.value.agency?.company.name), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(user.value.firstname) + " " + _toDisplayString(user.value.lastname), 1)
      ])
    ])
  ]))
}
}

})